export const formatUsPhone = (value) => {
  if (!value) return '';
  const digits = String(value).replace(/\D/g, '');
  if (digits.length < 10) return value;

  const last10 = digits.slice(-10);
  const area = last10.slice(0, 3);
  const prefix = last10.slice(3, 6);
  const line = last10.slice(6);

  return `(${area})-${prefix}-${line}`;
};

export const formatUsPhoneInput = (value) => {
  if (!value) return '';

  const digits = String(value).replace(/\D/g, '').slice(-10);
  const len = digits.length;

  if (len <= 3) return digits ? `(${digits}` : '';
  if (len <= 6) return `(${digits.slice(0, 3)})-${digits.slice(3)}`;
  return `(${digits.slice(0, 3)})-${digits.slice(3, 6)}-${digits.slice(6)}`;
};
